import React, { useState } from "react";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import styles from './_WorkflowTarefaObservacao.less';
import PropTypes from "prop-types";
import ActionBar from "../../../components/action-bar";
import ActionLink from "../../../components/action-link";

export default function WorkflowTarefaObservacao(props) {
  const { observacao, onSubmit, readOnly } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [edicao, setEdicao] = useState(false);

  const fireSubmit = observacao => {
    let promise = Promise.resolve();
    if (typeof onSubmit === 'function')
      promise = promise.then(() => onSubmit(observacao));
    return promise;
  }

  const handleClick = e => {
    if (readOnly)
      return;
    e.preventDefault();
    form.resetFields();
    setEdicao(true);
  }

  const handleFinish = values => {
    fireSubmit(values.observacao).then(() => setEdicao(false));
  }

  if (edicao) {
    return (
      <Form form={form} onFinish={handleFinish} size="middle">
        <Form.Item name="observacao" initialValue={observacao} noStyle>
          <Input.TextArea autoFocus autoSize placeholder={t('Observação')}/>
        </Form.Item>
        <ActionBar>
          <ActionLink.Save onClick={form.submit}/>
          <ActionLink.Cancel onClick={() => setEdicao(false)}/>
        </ActionBar>
      </Form>
    );
  }

  let className = styles['workflow-tarefa-observacao'];
  if (!observacao)
    className += ' ' + styles['nao-preenchido'];
  if (readOnly)
    className += ' ' + styles['read-only'];

  return (
    <div className={className} onClick={handleClick}>
      {observacao ?? t('(não preenchido)')}
    </div>
  );
}

WorkflowTarefaObservacao.propTypes = {
  observacao: PropTypes.string,
  onSubmit: PropTypes.func,
  readOnly: PropTypes.bool
}
